import React, {useEffect, useState} from 'react';
import moment from 'moment';
import styled from 'styled-components';

import { useSession } from '../../containers/App';
import { useInterval } from '../../hooks/useInterval';
import Button from '../../components/Button';

const activityEvents = ['mousedown', 'keydown'] as const

const urgent = 10

const convertMilisecondsToMinutes = (miliseconds: number) => {
  return Math.floor(miliseconds / 1000 / 60)
}

export function Session() {
  const [now, setNow] = useState<moment.Moment>(() => moment())
  const [shouldRefresh, setShouldRefresh] = useState(() => activityDetected && minutesLeft >= 0 && minutesLeft <= urgent)

  const { expiresAt, refreshToken, logout } = useSession()
  const [activityDetected, setActivityDetected] = useState(false)

  const expires = moment(expiresAt)
  const minutesLeft = convertMilisecondsToMinutes(expires.diff(now))
  const expired = minutesLeft < 0

  useEffect(() => {
    const registerActivity = () => {
      setActivityDetected(true)
    }

    activityEvents.forEach((activity) => {
      window.addEventListener(activity, registerActivity, false)
    })

    return () => {
      activityEvents.forEach((activity) => {
        window.removeEventListener(activity, registerActivity)
      })
    }
  }, [])

  useEffect(() => {
    if (expired) {
      logout()
    }
  }, [expired, logout])

  useEffect(() => {
    if (shouldRefresh) {
      setActivityDetected(false)
      refreshToken()
    }
  }, [shouldRefresh, refreshToken])

  useInterval(() => {
    setNow(moment())
  }, 60 * 1000)

  if (minutesLeft > urgent) {
    return null
  }

  // Display session time counter
  return <SessionInfo>
      Czas ważności sesji: {minutesLeft}min.
      <Button
            marginLeft
            width='120px'
            color="white"
            onClick={() => setShouldRefresh(true)}
            label='Odśwież'
            ariaLabel='Odśwież'
          />
    </SessionInfo>
}

const SessionInfo = styled.div`
  color: var(--color-text);
  background: var(--color-primary);
  display: flex;
  font-size: 0.8em;
  align-items: center;
  padding: 0 1em;
`
